import { useRepositoryMutation } from '@mews-commander/data-access';

export const useRateGroupsAdd = () =>
    useRepositoryMutation('rateGroups', 'add', {
        invalidateQueries: {
            rateGroups: ['getOverviewEntries'],
        },
    });
